import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchRealTimeWarehouseCountThunk } from "../../store/reports/thunk";
import "../../styles/global.css";
import noDataImage from "../../assets/no_data.png";
import {
  Home,
  PauseCircle,
  PlayCircle,
  ChevronLeftCircle,
  ChevronRightCircle,
} from "lucide-react";
import { APP_CONSTANTS } from "../../utilities/app_constants";
import { setDate } from "../../store/reports/actions";
import { fetchWarehouseThunk } from "../../store/redux/thunk";

const VehicleInformationReport = ({
  reportData,
  onNext,
  onPrevious,
  onPause,
  isPaused,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [params, setParams] = useState({});

  const { realTimeWarehouseCount, currentDate, loading, error } = useSelector(
    (state) => state.report
  );
  const { warehouse } = useSelector((state) => state.filter);
  console.log(warehouse);

  useEffect(() => {
    if (reportData?.url) {
      const urlParams = new URLSearchParams(reportData.url.split("?")[1]);
      const extractedParams = {
        warehouseId: urlParams.get("M_Warehouse_ID"),
        note: urlParams.get("Note"),
      };
      setParams(extractedParams);
    }
  }, [reportData]);

  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (params.warehouseId) {
      dispatch(fetchWarehouseThunk(params.warehouseId));
      const date = getCurrentDate();
      console.log("Setting date:", date);
      dispatch(setDate(date));
      dispatch(fetchRealTimeWarehouseCountThunk(params.warehouseId));
    }
  }, [dispatch, params]);

  useEffect(() => {
    if (!isPaused) {
      const intervalInSeconds = parseInt(reportData?.interval, 10);
      const displayTime =
        !isNaN(intervalInSeconds) && intervalInSeconds > 0
          ? intervalInSeconds * 1000
          : APP_CONSTANTS.REPORT_DISPLAY_TIME;

      const timeout = setTimeout(() => {
        onNext();
      }, displayTime);

      return () => clearTimeout(timeout);
    }
  }, [onNext, isPaused, reportData?.interval]);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
      .container {
        max-width: 100%;
        overflow-x: hidden;
      }
      
      .vehicle-table-container {
        overflow-x: auto;
        width: 100%;
        margin: 20px 0;
        border: 1px solid #ddd;
        border-radius: 4px;
      }
      
      .vehicle-data-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
        min-width: 1200px;
      }
      
      .vehicle-data-table th {
        background-color: #0070C0 !important;
        color: #FFFFFF !important;
        font-weight: bold !important;
        padding: 10px !important;
        text-align: center !important;
        border: 1px solid #ddd !important;
        white-space: nowrap;
      }
      
      .vehicle-data-table td {
        border: 1px solid #ddd;
        padding: 10px;
        text-align: center;
        vertical-align: middle;
        background-color: #FAFAFA;
      }
      
      .vehicle-table-header {
        background-color: #0066cc !important;
        color: white !important;
        text-align: center !important;
        font-weight: bold !important;
        font-size: 26px !important;
      }
      
      .product-cell {
        background-color: #ffffff !important;
      }
      
      .qty-cell {
        background-color: #ffffff !important;
       
      }
      
      .loading, .error {
        text-align: center;
        padding: 40px;
        font-size: 18px;
      }
      
      .no-data {
        text-align: center;
        padding: 40px;
      }
      
      @media (max-width: 1024px) {
        .header {
          flex-wrap: wrap !important;
          justify-content: center !important;
        }
        
        .header .home-button {
          order: 1;
        }
        
        .header .controls {
          order: 2;
        }
        
        .header h1 {
          order: 3;
          width: 100%;
          text-align: center;
          margin: 10px 0 !important;
        }
        
        .header .header-info {
          order: 4;
          width: 100%;
          justify-content: center !important;
          margin: 8px 0 !important;
        }
        
        .header .date-display {
          order: 5;
          margin: 8px auto !important;
        }
        
        .header .logo-container {
          order: 6;
          margin: 5px 0 !important;
        }
      }
      
      @media (max-width: 768px) {
        .header .controls svg {
          width: 32px !important;
          height: 32px !important;
        }
        
        .header h1 {
          font-size: 18px !important;
        }
        
        .current-date {
          width: 70px !important;
          font-size: 11px !important;
        }
        
        .vehicle-data-table th,
        .vehicle-data-table td {
          padding: 6px !important;
          font-size: 11px !important;
        }
        
        .vehicle-table-header {
          font-size: 18px !important;
        }
      }
      
      @media (max-width: 480px) {
        .header .controls {
          gap: 5px !important;
        }
        
        .header .controls svg {
          width: 28px !important;
          height: 28px !important;
        }
        
        .header h1 {
          font-size: 16px !important;
        }
        
        .current-date {
          width: 60px !important;
          font-size: 10px !important;
        }
        
        .vehicle-data-table th,
        .vehicle-data-table td {
          padding: 4px !important;
          font-size: 9px !important;
        }
        
        .vehicle-table-header {
          font-size: 14px !important;
        }
      }
    `;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const prepareTableData = () => {
    if (!realTimeWarehouseCount?.data?.length) return [];

    const groupedData = [];
    const vehicleGroups = {};

    realTimeWarehouseCount.data.forEach((item) => {
      if (!vehicleGroups[item.vehicleNo]) {
        vehicleGroups[item.vehicleNo] = {};
      }
      if (!vehicleGroups[item.vehicleNo][item.invoice]) {
        vehicleGroups[item.vehicleNo][item.invoice] = [];
      }
      vehicleGroups[item.vehicleNo][item.invoice].push(item);
    });

    Object.keys(vehicleGroups).forEach((vehicleNo, vehicleIdx) => {
      const vehicleGroup = vehicleGroups[vehicleNo];
      const allInvoiceItems = [];
      
      Object.keys(vehicleGroup).forEach((invoiceNo) => {
        const invoiceItems = vehicleGroup[invoiceNo];
        allInvoiceItems.push(...invoiceItems);
      });
      
      const totalRowsInVehicle = allInvoiceItems.length;
      let currentRowInVehicle = 0;
      
      Object.keys(vehicleGroup).forEach((invoiceNo, invoiceIdx) => {
        const invoiceItems = vehicleGroup[invoiceNo];
        const totalRowsInInvoice = invoiceItems.length;
        
        invoiceItems.forEach((item, itemIdx) => {
          groupedData.push({
            item,
            vehicleIdx,
            invoiceIdx,
            itemIdx,
            totalRowsInVehicle,
            totalRowsInInvoice,
            currentRowInVehicle,
            vehicleNo,
            invoiceNo,
            isFirstInVehicle: currentRowInVehicle === 0,
            isFirstInInvoice: itemIdx === 0,
          });
          currentRowInVehicle++;
        });
      });
    });
    
    return groupedData;
  };

  const tableData = prepareTableData();

  const mergedCellStyle = {
    textAlign: "center",
    verticalAlign: "middle",
    backgroundColor: "#fafafa",
  };

  const productCellStyle = {
    textAlign: "center",
    verticalAlign: "middle",
    backgroundColor: "#ffffff",
   
  };

  const qtyCellStyle = {
    textAlign: "center",
    verticalAlign: "middle",
    backgroundColor: "#ffffff",
  
  };

  const scrollingText = `${params?.note || ""}`;
  
  return (
    <div className="container" style={{ position: "relative", minHeight: "100vh" }}>
      <header
        className="header"
        style={{
          flexWrap: "wrap",
          gap: "1px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          className="home-button"
          onClick={() =>
            navigate("/menu", {
              state: { hideModal: true },
            })
          }
        >
          <Home
            className="home-icon"
            size={120}
            style={{
              width: "35px",
              height: "40px",
            }}
          />
        </button>
        
        <div
          className="controls"
          style={{ display: "flex", gap: "1px", alignItems: "center" }}
        >
          <ChevronLeftCircle
            size={40}
            onClick={onPrevious}
            style={{ cursor: "pointer" }}
          />
          {isPaused ? (
            <PlayCircle
              size={40}
              onClick={() => onPause(false)}
              style={{ cursor: "pointer" }}
            />
          ) : (
            <PauseCircle
              size={40}
              onClick={() => onPause(true)}
              style={{ cursor: "pointer" }}
            />
          )}
          <ChevronRightCircle
            size={40}
            onClick={onNext}
            style={{ cursor: "pointer" }}
          />
        </div>
        
        <h1 style={{ fontSize: "clamp(16px, 4vw, 28px)", margin: "5px 0" }}>
          Vehicle Information Report
        </h1>
        
        <div className="header-info">
          <span
            style={{
              color: "#FFEB3B",
              fontSize: "clamp(16px, 3vw, 28px)",
              fontWeight: "bold",
            }}
          >
            <span
              style={{
                background: "linear-gradient(90deg, #0A2A88, #1565C0)",
                color: "#FFFFFF",
                padding: "6px 9px",
                borderRadius: "30px",
                fontSize: "clamp(14px, 2vw, 28px)",
                fontWeight: "800",
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                border: "2px solid rgba(255,255,255,0.7)",
                letterSpacing: "0.5px",
                flexWrap: "wrap",
              }}
            >
              <span
                style={{
                  color: "#BBDEFB",
                  fontWeight: "700",
                  textTransform: "uppercase",
                  opacity: 0.9,
                }}
              >
                Warehouse
              </span>

              <span
                style={{
                  width: "2px",
                  height: "22px",
                  background: "rgba(255,255,255,0.5)",
                }}
              />

              <span
                style={{
                  color: "#FFFFFF",
                  wordBreak: "break-word",
                  maxWidth: "400px",
                  fontWeight: "900",
                  whiteSpace: "normal",
                  textShadow: "0 0 8px black, 0 0 12px black",
                }}
              >
                {warehouse?.data?.length > 0
                  ? warehouse.data[0].name
                  : "-"}
              </span>
            </span>
          </span>
        </div>

        <div
          className="date-display"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <span>Current Date:</span>
          <input
            type="text"
            value={currentDate}
            readOnly
            className="current-date"
            style={{
              width: "80px",
              minWidth: "80px",
              padding: "4px 8px",
              fontSize: "14px",
            }}
          />
        </div>
        
        <div className="logo-container">
          <a
            href="https://www.digiopenservices.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/Logo.png"
              alt="Logo"
              className="header-logo"
              style={{
                maxwidth: "110px",
                height: "40px",
                objectFit: "contain",
                borderRadius: "6px",
                margin: "2px 10px",
                cursor: "pointer",
              }}
            />
          </a>
        </div>
      </header>

      {loading && <p className="loading">Loading data, please wait...</p>}
      {error && <p className="error">{error}</p>}
      
      {!loading && realTimeWarehouseCount?.data?.length === 0 && (
        <div className="no-data">
          <img
            src={noDataImage}
            alt="No data available"
            className="no-data-image"
          />
          <p>No vehicle data available.</p>
        </div>
      )}

      {!loading && realTimeWarehouseCount?.data?.length > 0 && (
        <div className="vehicle-table-container">
          <table className="vehicle-data-table">
            <thead>
              <tr>
                <th colSpan="9" className="vehicle-table-header">
                  Vehicle Information
                </th>
              </tr>
              <tr>
                <th style={{ minWidth: "70px" }}>Serial No.</th>
                <th style={{ minWidth: "100px" }}>Invoice No.</th>
                <th style={{ minWidth: "100px" }}>Purpose</th>
                <th style={{ minWidth: "100px" }}>From / TO</th>
                <th style={{ minWidth: "100px" }}>Vehicle No.</th>
                <th style={{ minWidth: "90px" }}>Date</th>
                <th style={{ minWidth: "120px" }}>Product</th>
                <th style={{ minWidth: "100px" }}>Quantity Actual</th>
                <th style={{ minWidth: "130px" }}>Next Approver</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  {row.isFirstInVehicle && (
                    <td
                      rowSpan={row.totalRowsInVehicle}
                      style={mergedCellStyle}
                    >
                      {row.vehicleIdx + 1}
                    </td>
                  )}
                  
                  {row.isFirstInInvoice && (
                    <td
                      rowSpan={row.totalRowsInInvoice}
                      style={mergedCellStyle}
                    >
                      {row.invoiceNo}
                    </td>
                  )}
                  
                  {row.isFirstInInvoice && (
                    <td
                      rowSpan={row.totalRowsInInvoice}
                      style={mergedCellStyle}
                    >
                      {row.item.purpose || "-"}
                    </td>
                  )}
                  
                  {row.isFirstInInvoice && (
                    <td
                      rowSpan={row.totalRowsInInvoice}
                      style={mergedCellStyle}
                    >
                      {row.item.bpartner || "-"}
                    </td>
                  )}
                  
                  {row.isFirstInVehicle && (
                    <td
                      rowSpan={row.totalRowsInVehicle}
                      style={mergedCellStyle}
                    >
                      {row.vehicleNo}
                    </td>
                  )}
                  
                  {row.isFirstInVehicle && (
                    <td
                      rowSpan={row.totalRowsInVehicle}
                      style={mergedCellStyle}
                    >
                      {row.item.date || "-"}
                    </td>
                  )}
                  
                  <td style={productCellStyle} className="product-cell">
                    {row.item.product || "-"}
                  </td>
                  
                  <td style={qtyCellStyle} className="qty-cell">
                    {row.item.qtyActual || "-"}
                  </td>
                  
                  {row.isFirstInInvoice && (
                    <td
                      rowSpan={row.totalRowsInInvoice}
                      style={mergedCellStyle}
                    >
                      {row.item.nextApproval || "-"}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div
        style={{
          position: "fixed",
          bottom: "40px",
          left: 0,
          right: 0,
          color: "#022fe3",
          padding: "12px 0",
          overflow: "hidden",
          whiteSpace: "nowrap",
          fontFamily: "monospace",
          fontSize: "25px",
          fontWeight: "700",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            display: "inline-block",
            animation: "scrollRightToLeft 35s linear infinite",
            whiteSpace: "nowrap",
            paddingLeft: "100%",
          }}
        >
          <span>{scrollingText}</span>
        </div>

        <style>
          {`
            @keyframes scrollRightToLeft {
              0% {
                transform: translateX(0%);
              }
              100% {
                transform: translateX(-100%);
              }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default VehicleInformationReport;